// Generated by purs version 0.15.0
import * as Restaumatic_I18n_TranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
var t = /* #__PURE__ */ Restaumatic_I18n_TranslationKeys.unsafeMakeTranslationKeysProxy("");
export {
    t
};
//# sourceMappingURL=index.js.map
